// EPIC #92 P5 — parent "act-as" a managed child.
//
// When a parent switches into one of its managed children, we keep the child's
// account id here and send it as the `X-Acting-Account-Id` header on every
// portal API call (see services/api.js). The server ALWAYS re-verifies that the
// caller is the child's parent before honouring it, so this is a convenience
// selector, never the security boundary.
const KEY = 'acting_account_id'

export function getActingAccountId() {
  const v = localStorage.getItem(KEY)
  const n = v ? Number(v) : null
  return Number.isFinite(n) && n > 0 ? n : null
}

export function setActingAccountId(id) {
  if (id) localStorage.setItem(KEY, String(id))
  else localStorage.removeItem(KEY)
}

export function clearActingAccount() {
  localStorage.removeItem(KEY)
}
